// Externe Bibliotheken
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Interne Module
import { Calendar } from 'react-date-range';
import { de } from 'date-fns/locale';
import ClickOutside from '@/comp/clickOutside';

// Styles
import './singleDateInput.scss';

export class SingleDateInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            valid: false,
            value: this.props.value ?? '',
            validate: this.props.validate ?? false,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value }, () => {
                this.validateInput(this.props.value);
            });
        }

        if (this.props.validate !== prevProps.validate) {
            this.setState({ validate: this.props.validate });
        }
    }

    isNumber = (num) => /[0-9]/.test(num);

    validateInput(value) {
        if (value.length < 10) {
            this.setState({ valid: false });
            return false;
        }

        const dateParts = value.split('.');
        const date = new Date(dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0]);
        let valid = false;
        if (date instanceof Date && !isNaN(date?.getTime())) {
            const minDate = new Date('2010-01-01');
            const maxDate = new Date('2099-12-31');
            valid = !isNaN(date.getTime()) && minDate.getTime() < date.getTime() && maxDate.getTime() > date.getTime();

            this.setState({
                singleDate: date,
                validate: true,
                valid: valid,
            });
        }
        return valid;
    }

    handleDatepickerChange(value) {
        let startDate, collapsed, singleDate;
        if (value instanceof Object) {
            startDate =
                ('0' + value.getDate()).slice(-2) +
                '.' +
                ('0' + (value.getMonth() + 1)).slice(-2) +
                '.' +
                value.getFullYear();
            collapsed = !this.state.collapsed;
            singleDate = value;
        }
        this.setState(
            {
                value: startDate,
                collapsed: collapsed !== this.state.collapsed && collapsed,
                singleDate: singleDate !== this.state.singleDate && singleDate,
            },
            () => {
                let valid = this.validateInput(this.state.value);
                if (this.props.handleChange !== undefined) {
                    this.props.handleChange(this.props.name, this.state.value, valid);
                }
            }
        );
        this.props.handleChange({ target: { name: this.props.name, value: startDate } }, startDate);
    }

    handleInputChange(event) {
        const val = event.target.value;

        if (event.target.value.length > 10) {
            return false;
        }

        const result = [];

        if (val && val.length) {
            for (let i = 0; i < val.length; i++) {
                const current = val[i];

                // fast day or month selector (4. => 04.)
                if ((val.length === 2 || val.length === 5) && (i === 1 || i === 4) && current === '.') {
                    if (result[i - 1] > 0) {
                        let tmp = result[i - 1];
                        delete result[i - 1];
                        result.push('0');
                        result.push(tmp);
                        result.push('.');
                    }
                }

                if (i === 2 && current !== '.') {
                    result.push('.');
                } else if (i === 5 && current !== '.') {
                    result.push('.');
                }

                if ((this.isNumber(current) && i < 10) || i === 2 || i === 5) {
                    result.push(current);
                }
            }
        }

        this.setState({ value: result.join('') }, () => {
            let valid = this.validateInput(this.state.value);
            if (this.props.handleChange !== undefined) {
                this.props.handleChange(this.props.name, this.state.value, valid);
            }
        });
    }

    placeholderHelper(input) {
        let placeholder = 'TT.MM.JJJJ';
        let placeholderHelper = placeholder.slice(input.length).split('.');
        let placeholderHelperString = '';
        let classes = 'hide';
        if (input.indexOf('.') > 0) {
            classes += ' expand';
        }
        placeholderHelperString += '<span class="' + classes + '">' + input + '</span>';
        Object.keys(placeholderHelper).forEach((k) => {
            placeholderHelperString +=
                '<span class="' +
                placeholderHelper[k].slice(0, 1).toLowerCase() +
                '">' +
                placeholderHelper[k] +
                '</span>';
            if (placeholderHelper.length > parseInt(k) + 1) {
                placeholderHelperString += '.';
            }
        });

        return <div className="placeholder-helper" dangerouslySetInnerHTML={{ __html: placeholderHelperString }}></div>;
    }

    toggleCollapsed() {
        this.setState({ collapsed: !this.state.collapsed });
    }

    closeModal() {
        if (this.state.collapsed === true) {
            this.setState({ collapsed: false });
        }
    }

    render() {
        return (
            <div className={`singleDate-input component ${this.props.classList} ${this.state.valid ? 'valid' : ''}`}>
                <label htmlFor={this.props.inputName}>{this.props.label}</label>
                <div className="date-picker-wrapper">
                    <div className="travel-date-input input-container">
                        <input
                            id={'date'}
                            className={`${!this.state.valid && this.state.validate ? 'has-error' : ''}`}
                            type="text"
                            inputMode="numeric"
                            name={this.props.name}
                            maxLength="10"
                            value={this.state.value}
                            onBlur={(e) => {
                                this.handleInputChange(e);
                            }}
                            onChange={(e) => {
                                this.handleInputChange(e);
                            }}
                        />
                        {this.placeholderHelper(this.state.value)}
                    </div>
                    <span
                        className="material-symbols-outlined icon-calendar dateSpan"
                        onClick={() => {
                            this.toggleCollapsed();
                        }}>
                        calendar_month
                    </span>
                    <ClickOutside
                        className={'date-picker-overlay' + (this.state.collapsed ? ' collapsed' : '')}
                        onClick={() => {
                            this.closeModal();
                        }}>
                        <span
                            className="material-symbols-outlined icon-close"
                            onClick={() => {
                                this.toggleCollapsed();
                            }}>
                            close
                        </span>
                        <Calendar
                            locale={de}
                            date={this.state.singleDate}
                            months={window.$browserInfo?.device === 'mobile' ? 1 : 2}
                            onChange={(value) => this.handleDatepickerChange(value)}
                            direction="horizontal"
                            calendarFocus="backwards"
                            preventSnapRefocus={true}
                        />
                    </ClickOutside>
                </div>
                {this.state.validate && !this.state.valid && <div className="error">{this.props.errorText}</div>}
            </div>
        );
    }
}

export default SingleDateInput;

SingleDateInput.propTypes = {
    label: PropTypes.string,
    classList: PropTypes.string,
    name: PropTypes.string,
    validate: PropTypes.bool,
    handleChange: PropTypes.func,
};
